import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioDomUtils from "../common/dom_utils.js";
import IllumioSupportForm from "../common/support_form.js";
import IllumioSupportUtils from "../common/support_utils.js";

export class AccountContactListModel extends IllumioEventEmitter {
    constructor() {
        super();

        const csrf = IllumioSupportForm.getCsrf();
        this.authenticity_token = (csrf) ? csrf['authenticity_token'] : null,

        this.startIndex = 0;
        this.loadContacts(this.startIndex);
    }

    loadContacts(startIndex=0) {
        let queryString = (startIndex>0) ? `?start_index=${startIndex}` : '';
        this.emit('toggleSpinningIcon', { toggle: 'on' });
        $.ajax({
            dataType: 'json',
            method: 'get',
            contentType: 'application/json; charset=utf-8',
            url: `/api/v1/contact.json${queryString}`,
            error: this.ajaxErrorHandler.bind(this),
            success: (data, textStatus, jqXHR) => {
                this.ajaxCommonSuccessHandler(data, textStatus, jqXHR);
                this.emit('loadedContacts', { data: data });
            }
            // success: this.ajaxSuccessHandler.bind(this),
        });
    }
    
    /**
     * Delete selected contacts
     */
    deleteContacts(theForm) {
        const sfdcContactIds = [];
        for (const element of theForm['sfdc_contact_id'].values()) {
            if (element.checked) {
                sfdcContactIds.push(element.value);
            }
        }
        console.debug(sfdcContactIds);

        const payload = {
            authenticity_token: this.authenticity_token,
            sfdc_contact_ids: sfdcContactIds.join(','),
        };
        this.emit('toggleSpinningIcon', { toggle: 'on' });
        $.ajax({
            dataType: 'json',
            method: 'delete',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(payload),
            url: `/api/v1/contact/selected`,
            error: this.ajaxErrorHandler.bind(this),
            success: (data, textStatus, jqXHR) => {
                this.ajaxCommonSuccessHandler(data, textStatus, jqXHR);
                console.debug(`» deleteContacts(): this.startIndex: ${this.startIndex}`);
                this.loadContacts(this.startIndex);
            },
        });
    }

    /**
     * ES6: Private method
     */
    ajaxBeforeSendHandler(jqXHR, settings) {
        console.debug(jqXHR);
        console.debug(settings);
        // TODO: Update dom to display error message.
    }

    /**
     * ES6: Private method
     */
    ajaxErrorHandler(jqXHR, textStatus, errorThrown) {
        this.emit('toggleSpinningIcon');

        const responseJSON = jqXHR.responseJSON;
        const status = jqXHR.status;
        console.debug(responseJSON);
        console.debug(`» status: ${status}`);
        // console.error(textStatus);
        // console.error(errorThrown);
        /*
        if (theForm && status===406 && 
                responseJSON && responseJSON.success===false &&
                responseJSON.errors && Object.keys(responseJSON.errors).length>0) {
            const errorsForEachHandler = (fieldName) => {
                this.validateField(theForm[fieldName]);
            }
            Object.keys(responseJSON.errors).forEach((fieldName) => {
                this.validateField(theForm[fieldName]);
            }, this);
        } else if (responseJSON) {
            this.emit('updateSignupContent', { data: responseJSON });
        }
         */
    }

    /**
     * ES6: Private method
     */
    ajaxCommonSuccessHandler(data, textStatus, jqXHR) {
        console.info(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);
    }

    /**
     * ES6: Private method
     */
    generatePayload(theForm, token) {
        const csrf = IllumioSupportForm.getCsrf();

        return {
            title: theForm['title'].value,
            first_name: theForm['first_name'].value,
            last_name: theForm['last_name'].value,
            email: theForm['email'].value,
            email_confirm: theForm['email_confirm'].value,
            phone: theForm['phone'].value,
            city: theForm['city'].value,
            country: theForm['country'].options[theForm['country'].selectedIndex].value,
            timezone: theForm['timezone'].value,
            locale: theForm['locale'].value,
            token: token,
            authenticity_token: (csrf) ? csrf['authenticity_token'] : null,
        };
    }
}

export class AccountContactListView extends IllumioEventEmitter {
    constructor(model) {
        super();
        this.model = model;
       
        this.theForm = document.getElementById('theForm');

        this.contactListDesktop = document.getElementById('contactListDesktop');
        this.contactListMobile = document.getElementById('contacListMobile');
        this.contactListPagination = document.getElementById('contactListPagination');
        
        this.controlCheckbox = document.getElementById('controlCheckbox');

        const params = IllumioSupportUtils.getParameters(window.location.search);
        if (params && params.actions_widget==='true') {
            this.actionsWidget = true;

            if (this.controlCheckbox) {
                this.controlCheckbox.onclick = this.controlCheckboxOnClickHandler.bind(this);
                this.controlCheckbox.parentElement.classList.remove('hide');
            }

            const confirmDeleteContactsButton = document.getElementById('confirmDeleteContactsButton');
            if (confirmDeleteContactsButton) confirmDeleteContactsButton.onclick = this.confirmDeleteContactsButtonOnClickHandler.bind(this);
            const cancelDeleteContactsButton = document.getElementById('cancelDeleteContactsButton');
            if (cancelDeleteContactsButton) cancelDeleteContactsButton.onclick = () => { $('#confirmDeleteContactsModal').foundation('reveal', 'close'); }
        } else {
            this.actionsWidget = false;
            if (this.controlCheckbox) {
                controlCheckbox.parentElement.remove();
                this.controlCheckbox = null;
            }
        }

        this.spinningIcon = document.getElementById('spinningIcon');
        this.toggleSpinningIcon({ toggle: 'on' });

        this.model.on('loadedContacts', this.renderContacts.bind(this));
        this.model.on('toggleSpinningIcon', this.toggleSpinningIcon.bind(this));
    }

    /**
     * ES6: Private method
     */
    toggleSpinningIcon(args) {
        console.debug(`#toggleSpinningIcon(): ${JSON.stringify(args)}`);
        if (args && args.toggle && this.spinningIcon) {
console.debug(`» args.tootle: ${args.toggle}`);
console.debug(this.spinningIcon);
            if (args.toggle==='on') {
                // let listHeight = this.contactListDesktop.offsetHeight;
                // let listWidth = this.contactListDesktop.offsetWidth;
                // this.spinningIcon.style.height = listHeight+'px';
                // this.spinningIcon.style.width = listWidth+'px';
                // if (this.spinningIcon.childElementCount>0) {
                //     const fasIcon = this.spinningIcon.children[0];
                //     fasIcon.style.marginTop = ((listHeight-fasIcon.offsetHeight)/2)+'px';
                //     // fasIcon.style.marginLeft = ((listWidth-fasIcon.offsetWidth)/2)+'px';
                // }
                this.spinningIcon.classList.remove('hidden');
                this.spinningIcon.style.display = 'flex';
            } else {
                this.spinningIcon.classList.add('hidden');
                this.spinningIcon.style.display = 'none';
            }
        }
    }

    /**
     * ES6: Private method
     * Toggle input element error message. 
     * Invoked from model through event emitter.
     * args: { element: element, errorMessage: errorMessage }
     * @param {*} args 
     */
    renderContacts(args) {
        // console.debug(args);
        // console.debug(args.data);    
        if (args && args.data && args.data.contacts && args.data.metadata && this.contactListDesktop) {
            this.model.startIndex = args.data.metadata.start_index;
            console.debug(`renderContacts(): this.model.startIndex: ${this.model.startIndex}`);

            IllumioDomUtils.removeChildren(this.contactListDesktop.querySelector('tbody'));

            // Append new data row
            const contacts = args.data.contacts;
            if (contacts && contacts.length>0) {
                contacts.forEach(this.contactsForEachHandler.bind(this));
                this.theForm.parentElement.classList.remove('hide');

                this.renderPagination(args.data.metadata);
            }
            this.toggleActions(contacts && contacts.length>0 && this.actionsWidget);
            this.toggleSpinningIcon({ toggle: 'off' });
        }

        if (this.controlCheckbox && this.controlCheckbox.checked) this.controlCheckbox.checked = false;
    }

    /**
     * ES6: Private method
     */
    toggleActions(isShow=false) {
        const contactsActions = document.getElementById('contactsActions');
        if (contactsActions && isShow) {
            contactsActions.classList.remove('hide');
        } else if (contactsActions) {
            contactsActions.classList.add('hide');
        }
    }

    /**
     * ES6: Private method
     */
    contactsForEachHandler(contact) {
        // console.debug(contact);
        const trElement = document.createElement('tr');

        if (this.actionsWidget===true) {
            const checkboxElement = IllumioDomUtils.createInputTag('checkbox', 'sfdc_contact_id', contact.Id);
            checkboxElement.id = `contact${contact.Id}`;
            checkboxElement.onclick = this.dataCheckboxOnClickHandler;
            const tdElement = IllumioDomUtils.createTableCell(checkboxElement);
            trElement.append(tdElement);
        }
        
        let anchorElement = IllumioDomUtils.createAnchorTag(`/account/contact/${contact.Id}.html`, contact.Name);
        trElement.append(IllumioDomUtils.createTableCell(anchorElement)); // Name

        let element = IllumioDomUtils.createTableCell((contact.user_type) ? contact.user_type : '&nbsp;');
        if (element.textContent=='&nbsp;') {
            element.innerHTML = '&nbsp;' 
        }
        trElement.append(element); // User Type

        element = IllumioDomUtils.createTableCell((contact.Title) ? contact.Title : '&nbsp;');
        if (!contact.Title) {
            element.innerHTML = '&nbsp;';
        }
        trElement.append(element); // Title
        
        element = null;
        if (contact.Email) {
            anchorElement = IllumioDomUtils.createAnchorTag(`mailto:${contact.Email}`, contact.Email);
            element = IllumioDomUtils.createTableCell(anchorElement);
        } else {
            element = IllumioDomUtils.createTableCell('&nbsp;');
            element.innerHTML = '&nbsp';
        }
        trElement.append(element);

        /* 
        const buttonsCell = document.createElement('td');
        const viewButton = IllumioDomUtils.createNode('button', 'View', 'button radius tiny');
        const editButton = IllumioDomUtils.createNode('button', 'Edit', 'button radius tiny');
        const deleteButton = IllumioDomUtils.createNode('button', 'Remove', 'button radius tiny');
        viewButton.onclick = this.viewButtonOnClickHandler.bind(this);
        editButton.onclick = this.editButtonOnClickHandler.bind(this);
        deleteButton.onclick = this.deleteButtonOnClickHandler.bind(this);
        buttonsCell.append(deleteButton);
        buttonsCell.append(editButton);
        buttonsCell.append(viewButton);
        trElement.append(buttonsCell);
         */

        // this.contactListDesktop.append(trElement);
        const tbodyElement = this.contactListDesktop.querySelector('tbody');
        tbodyElement.appendChild(trElement);
        // console.debug(`» ${JSON.stringify(contact)}`);
        // console.debug(contact);
        // console.debug(trElement);
    }

    /**
     * ES6: Private method
     */
    viewButtonOnClickHandler(event) {
        console.debug(event);
    }

    /**
     * ES6: Private method
     */
    editButtonOnClickHandler(event) {
        console.debug(event);
    }

    /**
     * ES6: Private method
     */
    confirmDeleteContactsButtonOnClickHandler(event) {
        event.preventDefault();

        console.debug(`confirmDeleteContactsButtonOnClickHandler(): `);
        console.debug(event);
        console.debug(event.target);
        console.debug(event.currentTarget);
        console.debug(`event.currentTarget.checked: ${event.currentTarget.checked}`);
        console.debug(event.currentTarget.name);
        console.debug(event.currentTarget.value);
        console.debug(this);

        $('#confirmDeleteContactsModal').foundation('reveal', 'close');
        
        this.model.deleteContacts(this.theForm);
    }

    /**
     * ES6: Private method
     */
    dataCheckboxOnClickHandler(event) {
        console.debug(`dataCheckboxOnClickHandler(): `);
        console.debug(event);
        console.debug(event.target);
        console.debug(event.currentTarget);
        console.debug(`event.currentTarget.checked: ${event.currentTarget.checked}`);
        console.debug(event.currentTarget.name);
        console.debug(event.currentTarget.value);
        console.debug(this);
    }

    /**
     * ES6: Private method
     */
    controlCheckboxOnClickHandler(event) {
        console.debug(`controlCheckboxOnClickHandler`);
        console.debug(event);
        console.debug(event.target);
        console.debug(event.currentTarget);
        console.debug(`event.currentTarget.checked: ${event.currentTarget.checked}`);
        console.debug(event.currentTarget.name);
        console.debug(event.currentTarget.value);
        console.debug(this);
        
        for (let i=0;i<this.theForm['sfdc_contact_id'].length;i++) {
            this.theForm['sfdc_contact_id'][i].checked = event.currentTarget.checked;
        }
    }

    /**
     * ES6: Private method
     */
    contactListPaginationOnClickHandler(event) {
        event.preventDefault();

        console.debug(`anchorTagOnClick()`);
        console.debug(event);
        console.debug(event.currentTarget);
        console.debug(event.target);
        console.debug(this);

        let startIndex = parseInt(event.target.dataset['startIndex']);
        this.model.loadContacts(startIndex);

        return false;
    }

    /**
     * ES6: Private method
        <% @pagination_links.each_with_index do |link, index| %>
          <a class="join-item btn<%= link[:class_list] %>" <% if link[:is_disabled]==true %> disabled aria-disabled="true"<% end %> href="<%= link[:href]%>"><%= raw link[:link_text] %></a>
        <% end %>
     */
    renderPagination(metadata) {
        IllumioDomUtils.removeChildren(this.contactListPagination);
        
        if (metadata.pagination && metadata.pagination.pages && metadata.pagination.pages.length>1) {
            if (metadata.pagination.first_page_nav) {
                let anchorTag = null;
                if (metadata.pagination.first_page_nav.class_name && !metadata.pagination.first_page_nav.class_name.match(/unavailable/)) {
                    anchorTag = IllumioDomUtils.createAnchorTag('#', '«', null, 'startIndex', metadata.pagination.first_page_nav.start_index);
                    anchorTag.onclick = this.contactListPaginationOnClickHandler.bind(this);
                }
                this.contactListPagination.append(IllumioDomUtils.createNode('li', (anchorTag) ? anchorTag : '«', metadata.pagination.first_page_nav.class_name));
            }

            if (metadata.pagination.pages) {
                    metadata.pagination.pages.forEach((page) => {
                    const classNames = [ 'join-item', 'btn', 'hover:bg-server-slate-10' ];
                     if (page.page_number===metadata.current_page) {
                        classNames.push('btn-secondary');
                    } else {
                        classNames.push('btn-ghost');
                    }
                    let anchorTag = IllumioDomUtils.createAnchorTag('#', page.page_number, classNames.join(' '), 'startIndex', page.start_index);
                    anchorTag.onclick = this.contactListPaginationOnClickHandler.bind(this);
                    this.contactListPagination.append(anchorTag);
                    // this.contactListPagination.append(IllumioDomUtils.createNode('li', anchorTag, page.class_name));
                });

                if (this.theForm.nextElementSibling) {
                    this.theForm.nextElementSibling.classList.remove('hide');
                }
            }
            
            if (metadata.pagination.last_page_nav) {
                let anchorTag = null;
                if (metadata.pagination.last_page_nav.class_name && !metadata.pagination.last_page_nav.class_name.match(/unavailable/)) {
                    anchorTag = IllumioDomUtils.createAnchorTag('#', '»', null, 'startIndex', metadata.pagination.last_page_nav.start_index);
                    anchorTag.onclick = this.contactListPaginationOnClickHandler.bind(this);
                }
                this.contactListPagination.append(IllumioDomUtils.createNode('li', (anchorTag) ? anchorTag : '»', metadata.pagination.last_page_nav.class_name));
            }
        }
    }
}

export class AccountContactListController {
    constructor(model, view) {
        this.model = model;
        this.view = view;

        // view.on('inputElementOnBlur', event => this.inputElementOnBlurHandler(event));
        // view.on('fromElementOnSubmit', event => {
        //     this.formElementOnSubmitHandler(event);
        // });
    }
}
